import React from 'react';


export default function Logo() {
  return (
    <div className="logoContainer">
      <h1 className="app-logo">TREND!D</h1>
    </div>
  )
}
